import 'bootstrap';
import '@fancyapps/ui';
import React from 'react';

import './include/init-jquery';

import './include/sliders';
import './include/jquery-code';
import './include/init-maskedinput';

import Photo from "./tool/photo";

import "./vue/components";

import './react/AddToBasketButton';
import './react/AddWishlistButton';
import './react/City/Dialog';
import './react/Basket';


// run
new Photo();